<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'KALDIK'">
          <template v-slot:body>
            <div class="row" v-show="isKeyStudent">
                <div class="col-lg-6 pb-0">
                  <b-form-group label-cols="4" label-cols-lg="4" label="Tahun Akademik">
                    <Select2 v-model="filter.tahun_akademik" :options="generations" @change="SelectFilter($event)" :settings="{ allowClear: true }" />
                  </b-form-group>
                </div>
                <div class="col-lg-6 pb-0">
                  <b-form-group label-cols="4" label-cols-lg="4" label="WERVING">
                    <Select2 v-model="filter.angkatan" :options="angkatan" @change="SelectFilter($event)" :settings="{ allowClear: true }" />
                  </b-form-group>
                </div>
              </div>

            <div class="row mt-1 mb-5">
              <div class="col-lg-12">
                <div class="card-legend-jadwal d-flex  justify-content-center">
                  <!-- <template v-for="(item, i) in academicCalendarLegends">
                    <div class="legend-jadwal d-flex justify-content-between align-items-center" :key="i">
                      <div class="color-box" :style="backgroundColor(item.color)"></div>
                      <div>{{ item.name }}</div>
                    </div>
                  </template> -->
                </div>
              </div>
            </div>
            <!-- <div class="container">
            <div class="content"> -->
            <div class="row" id="pdf-content" style="overflow-x: scroll;">
                <div class="col">
                    <div class="row-md-12 text-center">
                      <div class="col-md-3">
                        <div class="row">
                          <p class="text-uppercase">
                            MARKAS BESAR TNI ANGKATAN DARAT
                          </p>
                        </div>
                        <div class="row" style="margin-top: -15px; border-bottom: 1px solid black; height: 20px;">
                          <p class="text-uppercase">
                            AKADEMI MILITER
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="row-md-12 text-center font-weight-bold">PERUBAHAN I</div>
                    <div class="row-md-12 text-center font-weight-bold">KALENDER PERKULIAHAN TARUNA AKADEMI MILITER TK {{tingkat_romawi}} TP {{tahun_pertama}} - {{tahun_akhir}}</div>
                    <div class="row-md-12 text-center font-weight-bold">KEPUTUSAN GUBERNUR AKADEMI MILITER</div>
                    <div class="row-md-12 mt-10">
                      <table class="font-weight-bold text-center" border="1" style="width: 100%; border: 2px solid black;">
                            <tr>
                                <td colspan="2" style="background-color: #fbfed8;">TAHUN</td>
                                <td v-for="(item, i) in data_hardcode.year" :key="i" :colspan="item.colspan">{{ item.val }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="background-color: #fefeca; color: #2420de;">SEMESTER</td>
                                <!-- <td colspan="26" v-bind:style="{ backgroundColor: warna_angkatan}" >{{semester_kaldik}} (TK {{tingkat_romawi}} WERVING {{ nama_angkatan }})</td> -->
                                <td v-bind:style="{ backgroundColor: warna_angkatan}" v-for="(item, i) in data_hardcode.semester" :key="i" :colspan="item.colspan">{{ item.val }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="background-color: #feff98; color: #2420de;">BULAN</td>
                                <td style="background-color: #84feff;" v-for="(item, i) in data_hardcode.bulan" :key="i" :colspan="item.colspan">{{ item.val }}</td>
                                
                            </tr>
                            <tr>
                                <td colspan="2" style="background-color: #fffe00; color: #2420de;">MINGGU</td>
                                <!-- <td v-bind:style="{ backgroundColor: warna_angkatan}" v-for="(jml_week, i) in jml_week" :key="i">{{ i+1 }}</td> -->
                                <td v-bind:style="{ backgroundColor: warna_angkatan}" v-for="(item, i) in data_hardcode.minggu" :key="i" :colspan="item.colspan">{{ item.val }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" style="background-color: #fdff02; color: #2420de;">TANGGAL</td>
                                <!-- <td v-for="(days, i) in days" :key="i" >{{ days[0] }} - {{ days[5] }}</td> -->
                                <!-- <td></td> -->
                                 
                                <td v-for="(item, i) in data_hardcode.tanggal" :key="i" :colspan="item.colspan" :style="`background-color: #${item.warna}`">{{ item.val }}</td>
                            </tr>
                            
                            <tr>
                              
                              <td colspan="2" rowspan="3" v-bind:style="{ backgroundColor: warna_angkatan}">TARUNA TINGKAT {{ tingkat_romawi }} W. {{ nama_angkatan }}</td>
                              <td v-for="(item, i) in data_hardcode.white" :key="i" :colspan="item.colspan" :style="`background-color: #${item.warna}; height: 100px;`"><p style="word-break: break-all;">{{ item.val }}</p></td>

                            </tr>
                            <tr>
                                <!-- <td v-for="(data, i) in data" :key="i" :style="`background-color: #${data.kode_warna}`" >{{ data.detail }}</td>
                                <td rowspan="7"></td> -->
                                
                                <!-- <td v-for="(item, i) in data_hardcode.kegiatan" :key="i" :colspan="item.colspan" :style="`background-color: ${item.warna}; vertical-align: middle; padding: 0.5rem;`"><p style="word-break: break-all;">{{ item.val }}</p></td> -->

                                <td class="vertical-text" v-for="(item, i) in data_hardcode.kegiatan" :key="i" :colspan="item.colspan" :style="`background-color: #${item.warna ? item.warna : warna_angkatan};`">{{ item.val }}</td>
                            </tr>
                            <tr>
                              <td v-for="(item, i) in data_hardcode.white" :key="i" :colspan="item.colspan" :style="`background-color: #${item.warna}; height: 100px;`"><p style="word-break: break-all;">{{ item.val }}</p></td>
                            </tr>
                            <!-- <tr>
                                <td rowspan="6">K<br>E<br>G<br>I<br>A<br>T<br>A<br>N</td>
                                <td>SENIN</td>
                                <td v-for="(data_senin, i) in data_senin" :key="i" :style="`background-color: #${data_senin.kode_warna}`" >{{ data_senin.detail }}</td>
                                <td rowspan="7"></td>
                            </tr>
                            <tr>
                                <td>SELASA</td>
                                <td v-for="(data_selasa, i) in data_selasa" :key="i" :style="`background-color: #${data_selasa.kode_warna}`" >{{ data_selasa.detail }}</td>
                            </tr>
                            <tr>
                                <td>RABU</td>
                                <td v-for="(data_rabu, i) in data_rabu" :key="i" :style="`background-color: #${data_rabu.kode_warna}`" >{{ data_rabu.detail }}</td>
                            </tr>
                            <tr>
                                <td>KAMIS</td>
                                <td v-for="(data_kamis, i) in data_kamis" :key="i" :style="`background-color: #${data_kamis.kode_warna}`" >{{ data_kamis.detail }}</td>
                            </tr>
                            <tr>
                                <td>JUMAT</td>
                                <td v-for="(data_jumat, i) in data_jumat" :key="i" :style="`background-color: #${data_jumat.kode_warna}`" >{{ data_jumat.detail }}</td>
                            </tr>
                            <tr>
                                <td>SABTU</td>
                                <td v-for="(data_sabtu, i) in data_sabtu" :key="i" :style="`background-color: #${data_sabtu.kode_warna}`" >{{ data_sabtu.detail }}</td>
                            </tr> -->
                        </table>
                    </div>
                </div>
            </div>
            <!-- </div>
            </div> -->
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CardContent.vue";
import axios from "axios"

export default {
  components: {
    KTCodePreview,
  },
  data() {
    return {
      angkatanOptions: [
        { value: null, text: '-- Pilih Tahun Akademik --' },
      ],
      attributes: [
      ],
      year: new Date().getFullYear(),
      schedules: [],
      academicCalendarLegends: [],
      academicCalendars: [],
      generations: [],
      angkatan: [],
      ProdiOptions: [],
      optionsTingkat: [
        { id: "I", text: "I" },
        { id: "II", text: "II" },
        { id: "III", text: "III" },
        { id: "IV", text: "IV" }
      ],
      filter: {
        tahun_akademik: null,
        prodi: null,
        angkatan: null,
        tingkat: null
      },
      jml_week: null,
      weeks: [],
      days: [],
      hari_temp: '',
      data: [],
      data_senin: [],
      data_selasa: [],
      data_rabu: [],
      data_kamis: [],
      data_jumat: [],
      data_sabtu: [],
      angkatan_romawi: null,
      tingkat_romawi: null,
      semester_kaldik: null,
      awal_kaldik: null,
      akhir_kaldik: null,
      nama_angkatan: null,
      tahun_pertama: null,
      tahun_akhir: null,
      warna_angkatan: null,
      myStyle:{
        backgroundColor: this.warna_angkatan
      },
      data_hardcode: []
    }
  },
  computed: {
    isKeyStudent() {
      return JSON.parse(localStorage.getItem('dataLogin')).grup_user != 3
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kalender Akademik View" }
    ]);
    
    await this.loadData();
    const dataLogin = JSON.parse(localStorage.getItem('dataLogin'));
    if (dataLogin.grup_user == 3) {
      this.filter.tahun_akademik = this.generations.find(gen => gen.id == dataLogin.key_generation).id
      const angkatas = this.generations.find(gen => gen.id == dataLogin.key_generation).text.split(" / ");
      this.filter.angkatan = this.angkatan.find(angkatan => angkatan.text == angkatas[0]).id
      this.SelectFilter();
    }
    // await this.getAcademicCalendar()
  },
  methods: {
    async loadData() {
      const data1 = this.getProdi();
      const data2 = this.getAngkatan()
      const data3 = this.getDataAngkatan()
      const data4 = this.AddLegenda()
      await Promise.all([data1, data2, data3, data4]);
    },
    bulan({ date }){
      let hari_ini = new Date(date).getFullYear() + "-" + (new Date(date).getMonth() + 1) + "-" + new Date(date).getDate()
      date = hari_ini
       
      this.$router.push({
        name: 'academic-calendar-view-monthly', params: { date }
      });
    },

    async getDataAngkatan() {
      await axios.get('master/angkatan')
          .then(response => {
            if (response.status == 200) {
              response.data.data.map((e, index) => {
                if(e.status == true) {
                  var object = { id: e.key, text: e.nama_angkatan, urutan: e.nama_angkatan }
                  // var object = { "id": e.key, "text": e.tahun + " " + e.semester }
                  this.angkatan.push(object);
                }
                return index > e.length;
              });
            }
          })
          this.sortedDes();
      },
      sortedDes() {
          return this.angkatan.sort((a, b) => {
            if (a.id && b.id) {
              if (b.urutan < a.urutan) return -1;
              if (b.urutan > a.urutan) return 1;
              return 0;
            }
          });
      },

    async getProdi() {
      await axios.get('master/study-programs?status=t')
        .then(response => {
          if (response.status == 200) {
            const filteredData = response.data.data.filter(item => item.program_code !== "N001");
            filteredData.some((e, index) => {
              var object = { "id": e.key, "text": e.program_name }
              this.ProdiOptions.push(object);
              return index > e.length;
            });
          }
        })
    },

    async getAngkatan() {
      try {
        await axios.get('master/generations')
          .then(response => {
            if (response.status == 200) {
              response.data.data.sort((a, b) => {
                if (b.tahun < a.tahun) return -1;
                if (b.tahun > a.tahun) return 1;
                return 0;
              });
              response.data.data.some((e, index) => {
                if(e.status == true && e.semester == 'Ganjil') {
                  let object = { "id": e.key, "text": e.tahun + " / " + e.tahun_akhir }
                  this.generations.push(object);
                  return index > e.length;
                }
              });
            }
          })
      } catch (err) {
          // this.$swal(`Failed`);
      }
    },
    
    changeAngkatan(selected) {
      // check if integer
      if (selected == !parseInt(selected, 10)) {
        alert('Data Angkatan Bukan Integer')
      }
      this.year = selected
    },

    async AddLegenda() {
        this.academicCalendarLegends = []
        await axios.get('master/activity')
        .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              if (e.status == true) {
                let objectLegend = {
                  'name': e.nama_kegiatan,
                  'color': "#" + e.kode_warna
                }
                this.academicCalendarLegends.push(objectLegend)
                return index > e.length;
              }
            });
          }
        })
    },

    async changeRomawi(angka) {
      let num = angka
      var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
      for ( i in lookup ) {
        while ( num >= lookup[i] ) {
          roman += i;
          num -= lookup[i];
        }
      }
      this.semester_kaldik = roman
    },

         
    async SelectFilter() {
      if (this.filter.angkatan !== null && this.filter.tahun_akademik !== null) {
        this.attributes = []
        await axios.get(`master/academic-calender/filter/?tahun_akademik=${this.filter.tahun_akademik}&angkatan=${this.filter.angkatan}&prodi=81002f30-3d83-47be-94bc-4f0dcc4d3846`)
        .then(response => {
          // Filter data berdasarkan tanggal mulai terlebih dahulu
          const filteredData = response.data.data.filter.sort((a, b) => new Date(a.tgl_mulai) - new Date(b.tgl_mulai));
          let num = filteredData[0]?.nama_angkatan
          var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
          for ( i in lookup ) {
            while ( num >= lookup[i] ) {
              roman += i;
              num -= lookup[i];
            }
          }
          if (filteredData[0]?.tingkat == "I") {
            this.warna_angkatan = '#fbddef'
          } else if (filteredData[0]?.tingkat == "II") {
            this.warna_angkatan = '#f598cc'
          } else if (filteredData[0]?.tingkat == "III") {
            this.warna_angkatan = '#f027ce'
          } else {
            this.warna_angkatan = '#91019c'
          }
          this.data_hardcode = []
          this.data_hardcode = response.data.data.pola_kaldik;
          this.angkatan_romawi = roman
          this.tingkat_romawi = filteredData[0]?.tingkat
          this.semester_kaldik = filteredData[0]?.semester_kaldik
          this.changeRomawi(filteredData[0]?.semester_kaldik)
          this.nama_angkatan = filteredData[0]?.nama_angkatan
          this.tahun_pertama = filteredData[0]?.tahun
          this.tahun_akhir = filteredData[0]?.tahun_akhir
          
          
        })
      }
    },
    async inputDay() {
      this.data.some((e,index) => {
              if (e.hari == 'Senin') {
                this.data_senin.push(e)
              } else if (e.hari == 'Selasa') {
                this.data_selasa.push(e)
              } else if (e.hari == 'Rabu') {
                this.data_rabu.push(e)
              } else if (e.hari == 'Kamis') {
                this.data_kamis.push(e)
              } else if (e.hari == 'Jumat') {
                this.data_jumat.push(e)
              } else if (e.hari == 'Sabtu') {
                this.data_sabtu.push(e)
              }
              return index > e.length;
            });
    },
    async getAcademicCalendar() {
      this.attributes = []
      await axios.get('master/academic-calender')
      .then(response => {
          let num = response.data.data[0].nama_angkatan
          var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
          for ( i in lookup ) {
            while ( num >= lookup[i] ) {
              roman += i;
              num -= lookup[i];
            }
          }
          this.angkatan_romawi = roman
          this.tingkat_romawi = response.data.data[0].tingkat
          this.semester_kaldik = response.data.data[0].semester_kaldik
          if (response.status == 200) {
            const weekday = ["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"];
            const month = ["Januari","Februari","Maret","April","Mei","Juni","Juli", "Agustus", "September", "Oktober", "November", "Desember"];
            let count_data = (response.data.data.length) - 1
            const start = new Date(response.data.data[0].tgl_mulai);
            const end = new Date(response.data.data[count_data].tgl_akhir);
            this.awal_kaldik = start.getDate() + ' ' + month[start.getMonth()] + ' ' + start.getFullYear()
            this.akhir_kaldik = end.getDate() + ' ' + month[end.getMonth()] + ' ' + end.getFullYear()
            const DAY = 24 * 60 * 60 * 1000;

            this.weeks = [];
            for (let newStart = start.valueOf(); newStart < end; newStart += DAY * 7) {
              const days = [];
              const day = [];

              for (let d = newStart; d < newStart + 6 * DAY; d += DAY) {
                days.push(new Date(d));
                day.push(new Date(d).getDate());
              }
              this.weeks.push(days);
              this.days.push(day);
            }
            this.jml_week = this.weeks.length
            this.data = []
            this.data_senin = []
            this.data_selasa = []
            this.data_rabu = []
            this.data_kamis = []
            this.data_jumat = []
            this.data_sabtu = []
            response.data.data.some((e, index) => {
              if (e.total_hari >= 1) {
                var day = 60 * 60 * 24 * 1000;
                let tgl_mulai_temp = null
                let hari = null
                for (let d = 0; d <= e.total_hari; d++) {
                  if (d == 0) {
                    hari = weekday[new Date(e.tgl_mulai).getDay()]
                    if (hari == 'Senin') {
                      this.data_senin.push(e)
                    } else if (hari == 'Selasa') {
                      this.data_selasa.push(e)
                    } else if (hari == 'Rabu') {
                      this.data_rabu.push(e)
                    } else if (hari == 'Kamis') {
                      this.data_kamis.push(e)
                    } else if (hari == 'Jumat') {
                      this.data_jumat.push(e)
                    } else if (hari == 'Sabtu') {
                      this.data_sabtu.push(e)
                    }
                    tgl_mulai_temp = e.tgl_mulai
                  } else {
                    tgl_mulai_temp = new Date(tgl_mulai_temp).getTime() + day;
                    hari = weekday[new Date(tgl_mulai_temp).getDay()]
                    if (hari == 'Senin') {
                      this.data_senin.push(e)
                    } else if (hari == 'Selasa') {
                      this.data_selasa.push(e)
                    } else if (hari == 'Rabu') {
                      this.data_rabu.push(e)
                    } else if (hari == 'Kamis') {
                      this.data_kamis.push(e)
                    } else if (hari == 'Jumat') {
                      this.data_jumat.push(e)
                    } else if (hari == 'Sabtu') {
                      this.data_sabtu.push(e)
                    }
                  }
                }
              } else {
                e.hari = weekday[new Date(e.tgl_mulai).getDay()]
                if (e.hari == 'Senin') {
                      this.data_senin.push(e)
                    } else if (e.hari == 'Selasa') {
                      this.data_selasa.push(e)
                    } else if (e.hari == 'Rabu') {
                      this.data_rabu.push(e)
                    } else if (e.hari == 'Kamis') {
                      this.data_kamis.push(e)
                    } else if (e.hari == 'Jumat') {
                      this.data_jumat.push(e)
                    } else if (e.hari == 'Sabtu') {
                      this.data_sabtu.push(e)
                    }
              }
              return index > e.length;
            });
          }
        })
    },

    backgroundColor(color) {
      return {
        backgroundColor: color
      }
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/jadwal.css";
.warna-cal {
  color: white !important;
}
.warna-cal {
  color: white !important;
}
.vertical-text {
    writing-mode: vertical-rl; /* or vertical-lr */
    text-orientation: upright;
}
</style>